import { selector } from 'recoil';
import { jobAtom } from '../atoms/jobAtom';

export const isOpcJobSelector = selector<boolean>({
    key: 'isOpcJobSelector',
    get: ({ get }) => {
        const { isOpcJob } = get(jobAtom);
        return isOpcJob ?? false;
    }
});
